export interface ChangeWorkOrderStageOperatorPriority {
	operatorPriority: number;
	workOrderStageId: number;
}

export class ChangeWorkOrderStageOperatorPriority implements ChangeWorkOrderStageOperatorPriority {
	constructor(data?: Partial<ChangeWorkOrderStageOperatorPriority>) {
		if (data) {
			for (const key of Object.keys(data)) {
				(this as any)[key] = (data as any)[key];
			}
		}
	}
}
